import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { getPathnameByType, ROUTE_PAGE } from '$routes';
import { ControlActions, LocationActions } from '~store/actions';
import { selectMenuStartPageAlias, selectUrlLanguagePrefix } from '~store/selectors';

export const useNavigateToPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const lang = useSelector(selectUrlLanguagePrefix);

  const redirect = async (type: string, payload: Record<string, string> = {}) => {
    // we sill need this in the store to use selectors
    if (payload.slug) await dispatch(ControlActions.setActiveAnchor(payload.slug));
    if (payload.pageAlias) await dispatch(LocationActions.setPageAlias(payload.pageAlias));

    // add language if not specified
    if (!payload.lang) payload.lang = lang;

    const path = getPathnameByType(type, payload);
    navigate(path);
  };

  return redirect;
};

export const useNavigateToDefault = () => {
  const navigateToPage = useNavigateToPage();
  const pageAlias = useSelector(selectMenuStartPageAlias);
  return () => {
    if (pageAlias) {
      navigateToPage(ROUTE_PAGE, { pageAlias });
    }
  };
};
